import img1 from './Egypt/Abu_Simbel_Temples.jpg'
import img2 from './Egypt/Alexandria.jpg'
import img3 from './Egypt/Aziz_Abaza.jpg'
import img4 from './Egypt/Cairo.jpg'
import img5 from './Egypt/Diving.jpg'
import img6 from './Egypt/El_Manial.jpg'
import img7 from './Egypt/Giza_Plateau.jpg'
import img8 from './Egypt/Giza.jpg'
import img9 from './Egypt/Khan_Al_Khalili.jpg'
import img10 from './Egypt/Luxor.jpg'
import img11 from './Egypt/Marsa_Matrouh.jpg'
import img12 from './Egypt/Plateau_Hurghada.jpg'
import img13 from './Egypt/Ras_El_Bar.jpg'
import img14 from './Egypt/Red_sea.jpg'
import img15 from './Egypt/Sphinx.jpg'
import img16 from './img/snow.jpg'
import img17 from './img/sydneySouth.jpg'
import img18 from './img/tropical.jpg'
import img19 from './img/venice.jpg'
const displayArray = [
  {
    value: 0,
    title: 'Abu Simbel Temples',
    subtitle: '',
    src: img1,
    link: ''
  },
  {
    value: 100,
    title: 'Alexandria',
    subtitle: '',
    src: img2,
    link: ''
  },
  {
    value: 200,
    title: 'Aziz Abaza',
    subtitle: '',
    src: img3,
    link: ''
  },
  {
    value: 300,
    title: 'Cairo',
    subtitle: '',
    src: img4,
    link: ''
  },
  {
    value: 400,
    title: 'Diving',
    subtitle: '',
    src: img5,
    link: ''
  },
  {
    value: 500,
    title: 'El Manial',
    subtitle: 'Old Cario',
    src: img6,
    link: ''
  },
  {
    value: 600,
    title: 'Giza Plateau',
    subtitle: '',
    src: img7,
    link: ''
  },
  {
    value: 700,
    title: 'Giza',
    subtitle: '',
    src: img8,
    link: ''
  },
  {
    value: 800,
    title: 'Khan Al Khalili',
    subtitle: '',
    src: img9,
    link: ''
  },
  {
    value: 900,
    title: 'Luxor',
    subtitle: '',
    src: img10,
    link: ''
  },
  {
    value: 1000,
    title: 'Marsa Matrouh',
    subtitle: '',
    src: img11,
    link: ''
  },
  {
    value: 1100,
    title: 'Plateau Hurghada',
    subtitle: '',
    src: img12,
    link: ''
  },
  {
    value: 1200,
    title: 'Ras El-Bar',
    subtitle: '',
    src: img13,
    link: ''
  },
  {
    value: 1300,
    title: 'The Red Sea',
    subtitle: '',
    src: img14,
    link: ''
  },
  {
    value: 1400,
    title: 'The Sphinx',
    subtitle: '',
    src: img15,
    link: ''
  },
  // {
  //   value: 1500,
  //   title: '',
  //   src: img16
  // },
  // {
  //   value: 1600,
  //   title: '',
  //   src: img17
  // },
  // {
  //   value: 1700,
  //   title: '',
  //   src: img18
  // },
  // {
  //   value: 1800,
  //   title: '',
  //   src: img19
  // },
]
export default displayArray